import { useCollection } from "@/hooks/useCollection";
import type { WhySupport as WhySupportItem } from "@/lib/types";

export default function WhySupport() {
  const { items } = useCollection<WhySupportItem>("why_support");

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-sm font-semibold text-accent-600">
            Pourquoi nous soutenir ?
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Votre générosité, notre responsabilité
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Soutenir Humanity59, c'est faire un choix clair et engagé.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, index) => (
            <div
              key={item.title || index}
              className="bg-background-50 rounded-lg p-6 border border-background-200"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}